import { render, staticRenderFns } from "./CounselingEvent.vue?vue&type=template&id=c5ae0d54&"
import script from "./CounselingEvent.vue?vue&type=script&lang=js&"
export * from "./CounselingEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports